import { render, staticRenderFns } from "./BaseFileInput.vue?vue&type=template&id=2da8e51d&scoped=true&"
import script from "./BaseFileInput.vue?vue&type=script&lang=js&"
export * from "./BaseFileInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileInput.vue?vue&type=style&index=0&id=2da8e51d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8e51d",
  null
  
)

export default component.exports